export const EXCEPTION_OPTIONS = [
  'wrongTotal',
  'missingVat',
  'invalidSupplier',
  'invoiceNotSigned',
  'unknownField',
];
